export enum PlanType {
  Network = 'Для мереж',
  Subscription = 'Підписка',
  FOP = 'Для ФОП',
  LegalEntity = 'Для юридичних осіб',
  EventTranslation = 'Переклад подій/заходів',
}
